<template>
    <div>
        <el-dialog
            title="修改有效期"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="120px">
                <el-form-item label="失效时间" prop="expireTime">
                    <el-date-picker
                        disabled
                        :editable="false"
                        v-model="form.expireTime"
                        type="datetime"
                        value-format="timestamp"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="form.operation==1?'增加天数（天）':'减少天数（天）'" prop="day">
                    <el-input placeholder="请输入内容" v-model="form.day" class="input-with-select" @input="form.day=form.day.replace(/^(0+)|[^\d]+/g,'')" @blur="daysChange">
                        <el-select v-model="form.operation" slot="prepend" placeholder="请选择" style="width:100px">
                            <el-option label="增加" :value="1"></el-option>
                            <el-option label="减少" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false,
                form: {
                    userMonthCardId: '',
                    day: '',
                    expireTime: '',
                    operation: 1
                },
                expireTime: '',
                rules: {

                }
            };
        },
        watch:{
            dialogVisible () {
                this.form.day = ''
                this.form.operation = 1
            }
        },
        methods:{
            submit () {
                this.$confirm('是否确认增加月卡时间？', '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(_=>{
                    this.form.day = Number(this.form.day)
                    this.$Axios._post({
                        url: this.$Config.apiUrl.addUserMonthCardTime,
                        method: "post",
                        params: this.form,
                    })
                    .then(res=>{
                        if (res.result.code == 0) {
                            this.$message.success('操作成功')
                            this.$emit('updatePage');
                            this.dialogVisible = false
                        } else {
                            this.$message.error(res.result.message)
                        }
                    })
                    .catch(err=>{

                    })
                }).catch(_=>{ })
            },
            daysChange () {
                if(this.form.day){
                    if(this.form.operation == 1){
                        this.form.expireTime = this.expireTime + (Number(this.form.day) * 24 * 60 * 60 * 1000)
                    }else if(this.form.operation == 2){
                        this.form.expireTime = this.expireTime - (Number(this.form.day) * 24 * 60 * 60 * 1000)
                    }
                }else{
                    this.form.expireTime = this.expireTime
                }
            }
        }
    }
</script>